import axios from "axios"
import { GetCompanySize, HEADERS } from "../pages/api";
export default async function CompanySizeService() {
    const responseData = [];
    try {
        const response = await axios.get(GetCompanySize, {
            headers: HEADERS
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching data:', error);
        throw new Error('Failed to fetch data');
    }
}